// Central brand data for the public-facing organic site.
// Use these constants instead of hardcoding strings.

export const brand = {
  legalName: "Comprehensive Tax Resolution LLC",
  shortName: "Comprehensive Tax Resolution",
  initials: "CTR",
  tagline: "CPA-led IRS tax resolution for individuals and businesses",
  description:
    "Comprehensive Tax Resolution LLC is a CPA firm helping individuals and businesses resolve IRS and state tax problems — back taxes, wage garnishments, levies, audits, and Offers in Compromise.",
  founded: 2009,
  yearsExperience: 15,
  phone: "(214) 646-3802",
  phoneTel: "+12146463802",
  email: "info@comprehensivetaxresolution.com",
  address: {
    // "Suite 620" matches Google Business Profile exactly (citation parity).
    // Keep this string identical to GBP and Yelp/BBB listings.
    street: "291 S Preston Rd Suite 620",
    city: "Prosper",
    region: "TX",
    postalCode: "75078",
    country: "US",
    full: "291 S Preston Rd Suite 620, Prosper, TX 75078",
  },
  // Hours match GBP (M-F 9:00am-6:00pm CT) — kept in sync to avoid local-pack penalty.
  hours: "Mon–Fri 9:00am–6:00pm CT",
  hoursOpen: "09:00",
  hoursClose: "18:00",
  domain: "comprehensivetaxresolution.com",
  siteUrl: "https://comprehensivetaxresolution.com",
  social: {
    google: "https://www.google.com/search?q=Comprehensive+Tax+Resolution+LLC+Prosper+TX",
    facebook: "https://www.facebook.com/profile.php?id=100087655152231",
    linkedin: "https://www.linkedin.com/company/comprehensive-tax-resolution-llc/?trk=public_post_follow-view-profile",
  },
} as const;

export const founder = {
  name: "Franklin Sofi",
  credentials: "MBA, CPA, CTRS",
  title: "Founder & Tax Resolution Specialist",
  image: "/team/franklin-sofi.jpg",
  bio: "Franklin Sofi is the founder of Comprehensive Tax Resolution LLC. He holds an MBA and is a Certified Public Accountant (CPA), Certified Tax Resolution Specialist (CTRS), and a Gold Member of the American Society of Tax Problem Solvers (ASTPS). For more than 15 years he has represented individuals and businesses in front of the IRS — negotiating Offers in Compromise, releasing wage garnishments and bank levies, defending audits, and resolving payroll-tax liabilities.",
  credentialsList: [
    "Certified Public Accountant (CPA)",
    "Certified Tax Resolution Specialist (CTRS)",
    "ASTPS Gold Member",
    "MBA in Finance",
    "15+ years of IRS representation experience",
  ],
  sameAs: [
    "https://www.linkedin.com/in/franklin-sofi/",
    "https://astps.org/find-a-tax-problem-solver/",
    "https://www.aicpa-cima.com/",
    "https://www.tsbpa.texas.gov/",
    "https://www.google.com/search?q=Comprehensive+Tax+Resolution+LLC+Prosper+TX",
  ],
  verifyLinks: [
    {
      label: "Texas State Board of Public Accountancy — CPA license lookup",
      href: "https://www.tsbpa.texas.gov/internet/online-license-lookup.html",
      org: "Texas State Board of Public Accountancy",
    },
    {
      label: "ASTPS — Find a Tax Problem Solver directory",
      href: "https://astps.org/find-a-tax-problem-solver/",
      org: "American Society of Tax Problem Solvers",
    },
    {
      label: "IRS — Directory of Federal Tax Return Preparers (PTIN)",
      href: "https://irs.treasury.gov/rpo/rpo.jsf",
      org: "Internal Revenue Service",
    },
  ],
} as const;
